import * as React from 'react';
import { NavLink } from 'react-router-dom';
import routes from '../../../routes';
import { connect } from "react-redux";
import { scroller } from 'react-scroll';

import logoWhite from '../../../images/icons/logo-restyle.svg';
import logoBlack from '../../../images/icons/logo-restyle-black.svg';

import * as styles from './TopNavigation.module.scss';

class TopNavigation extends React.Component {
  state = {
    isOpen: false
  };

  handleClick = () => {
    this.setState((state) => ({
      isOpen: !state.isOpen
    }));
  };

  scrollToTop = () => {
    scroller.scrollTo('RealEstateGlobally', {
      duration: 1500,
      smooth: true
    });
  };

  render() {
    const { isOpen } = this.state;
    const { darkTheme } = this.props;
    const openMenuIcon = darkTheme ? styles.openIconBlack : styles.openIconWhite;
    const menuClass = isOpen ? styles.openMenuContainer : styles.closeMenuContainer;

    return (
      <header className={styles.root} style={isOpen ? {zIndex: 4} : null}>
        <div className={styles.container}>
          <div className={styles.logoIcon} onClick={this.scrollToTop}>
            <img src={isOpen ? logoWhite : darkTheme ? logoBlack : logoWhite} alt='Flatfy logo' />
          </div>
          <div className={isOpen ? styles.closeIcon : openMenuIcon} onClick={this.handleClick} />
        </div>
        <section className={menuClass}>
          <ul>
            {routes.map((route, index) => (
              <li key={index} onClick={this.handleClick}>
                <NavLink to={route.path}>
                  {route.title}
                </NavLink>
              </li>
            ))}
            <li onClick={this.handleClick}>
              <a href="https://flatfy.com/infographics">
                Infographics
              </a>
            </li>
          </ul>
        </section>
      </header>
    );
  }
}

const mapStateToProps = state => ({
  darkTheme: state.topNavigationStyles.darkTheme
});

export default connect(mapStateToProps)(TopNavigation);
